import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'listings',
    lazy: async () => ({ Component: (await import('./ListingsPage')).ListingsPage }),
  },
];
